import { PermitType } from '@contracts/permitType/PermitType';
import type { AutocompleteRenderInputParams } from '@mui/material/Autocomplete';
import { MultipleAutocomplete } from '@src/common/components/Autocomplete';
import { TextInput } from '@src/common/components/TextInput';
import { PermitTypeFormatter } from '@src/permits/permitSearch/PermitTypeFormatter';
import type { SearchPermitFilters } from '@src/permits/services/PermitApplicationClient';
import { useTranslation } from 'react-i18next';

interface Props {
  onFilterChange: (filters: SearchPermitFilters) => void;
  value?: string[];
}

export const PermitTypeFilter = ({ onFilterChange, value }: Props) => {
  const { t } = useTranslation();
  const getOptionLabel = (option: unknown): string => {
    if (typeof option === 'string') {
      return PermitTypeFormatter.format(option);
    }
    return '';
  };

  const renderInput = (params: AutocompleteRenderInputParams) => (
    <TextInput {...params} label={t('permitSearch.permitType')} />
  );

  const permitTypeOptions = PermitType;

  const selectedOptions = permitTypeOptions.filter((type) =>
    value?.includes(type),
  );

  const handleChange = (_: unknown, selectedValues: unknown) => {
    if (Array.isArray(selectedValues)) {
      const types = selectedValues
        .filter((val): val is string => typeof val === 'string')
        .filter(Boolean);
      onFilterChange({ type: types });
    } else {
      onFilterChange({ type: [] });
    }
  };
  return (
    <MultipleAutocomplete
      value={selectedOptions}
      onChange={handleChange}
      options={permitTypeOptions}
      getOptionLabel={getOptionLabel}
      renderInput={renderInput}
    />
  );
};
